document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth <= 767) {

        const el = document.querySelector('.Innovation_innersingle_mainblock_new');

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    setTimeout(() => {
                        el.classList.add('active');
                    }, 500);

                    observer.unobserve(el);
                }
            });
        });

        observer.observe(el);
    }
});